import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import backgroundImage from '../../assets/imagen_fondo_2.jpeg';
import './Hero.css';

function Hero() {
  const { t } = useTranslation();

  return (
    <section className="hero-section">
      <div 
        className="hero-background"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      ></div>
      <div className="hero-gradient"></div>
      
      <Container className="hero-content">
        <Row className="justify-content-center text-center">
          <Col lg={10} className="px-6">
            <h2 className="hero-title">
                {t('hero.micropigmentation')}
            </h2>
            <p className="hero-subtitle">
                {t('hero.browEyelashes')}
            </p>
            <div className="hero-buttons">
              <Button 
                href="#contact" 
                className="hero-button"
                variant="primary"
              >
                {t('hero.bookSession')}
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Hero;
